import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CouponsComponent } from './coupons/coupons.component';
import { AddUpdateCouponComponent } from './add-update-coupon/add-update-coupon.component';
import { CouponDetailsComponent } from './coupon-details/coupon-details.component';

const routes: Routes = [
  {
    path: '',
    component: CouponsComponent,
  },
  {
    path: 'add',
    component: AddUpdateCouponComponent,
  },
  {
    path: 'update/:id',
    component: AddUpdateCouponComponent,
  },
  {
    path: 'analytics/:id',
    component: CouponDetailsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CouponRoutingModule {}
